// extracted by mini-css-extract-plugin
export var category = "_ld-9";
export var categoryHeader = "_ld-e";
export var container = "_ld-0";
export var group = "_ld-a";
export var groupItems = "_ld-f";
export var groupSeparator = "_ld-j";
export var loading = "_ld-1";
export var noResults = "_ld-3";
export var placeholder = "_ld-2";
export var resultContent = "_ld-5";
export var resultIcon = "_ld-c";
export var resultItem = "_ld-g";
export var resultMeta = "_ld-8";
export var resultSubtitle = "_ld-7";
export var resultSuffix = "_ld-i";
export var resultTitle = "_ld-6";
export var resultsList = "_ld-4";
export var searchGroup = "_ld-d";
export var selected = "_ld-h";
export var subgroup = "_ld-b";